// extracted by mini-css-extract-plugin
export default {"swipeContainer":"style_swipeContainer__VWzlc"};